import script from "./AdminQuotesView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminQuotesView.vue?vue&type=script&setup=true&lang=js"

import "./AdminQuotesView.vue?vue&type=style&index=0&id=002416fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002416fa"]])

export default __exports__